import { render, staticRenderFns } from "./TrainingCalendarWeekSummaryFuture.vue?vue&type=template&id=a4c0f4dc&"
import script from "./TrainingCalendarWeekSummaryFuture.vue?vue&type=script&lang=ts&"
export * from "./TrainingCalendarWeekSummaryFuture.vue?vue&type=script&lang=ts&"
import style0 from "./TrainingCalendarWeekSummaryFuture.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports